import {
  IonContent,
  IonHeader,
  IonIcon,
  IonInput,
  IonItem,
  IonLabel,
  IonList,
  IonModal,
  IonSearchbar,
  IonTitle,
  IonToolbar,
} from "@ionic/react";
import { radioButtonOffOutline, radioButtonOnOutline } from "ionicons/icons";
import { useEffect, useState } from "react";
import StyledButton from "../StyledButton/StyledButton";
import CustomInput from "../CustomInput/CustomInput";
import { Typography } from "@mui/joy";
import "./CustomDesplegable.css";

const CustomDesplegable = ({
  array,
  handleChange,
  mostrarTodos,
  mostrarSearch,
  label,
  id,
  value,
  isOpen,
  setIsOpen,
  placeholder,
  error,
  errorHelperText,
  helperText,
  disabled,
  variant,
  className,
  style,
}) => {
  const [texto, setTexto] = useState("");
  const [searchText, setSearchText] = useState("");
  const [options, setOptions] = useState(false);
  const [opcionesValidas, setOpcionesValidas] = useState([]);

  const buscarTextoOpcion = (codigoOpcion) => {
    let texto = "";
    array.map((item) => {
      if (item.codigo === codigoOpcion) texto = item.text;
    });
    setTexto(texto);
  };

  const onHandleChange = (value, textLabel) => {
    handleChange(value, id);
    buscarTextoOpcion(value);
    setIsOpen(false);
  };

  const FiltrarOpciones = (ev) => {
    const texto = ev.target.value;
    const opciones = array.filter((item) =>
      item.text.toLowerCase().includes(texto.toLowerCase())
    );
    setOpcionesValidas(opciones);
    setSearchText(texto);
  };

  const cargarInputs = () => {
    const arrayInputs = [];

    if (mostrarTodos) {
      arrayInputs.push({
        label: "Mostrar todos",
        type: "radio",
        value: -1,
        checked: -1 === value && mostrarTodos,
        handler: (target) => onHandleChange(target.value),
      });
    }

    array.forEach((item) => {
      arrayInputs.push({
        label: item.text,
        type: "radio",
        value: item.codigo,
        checked: item.codigo === value,
        handler: (target) => onHandleChange(target.value),
      });
    });

    return arrayInputs;
  };

  useEffect(() => {
    if (isOpen) {
      setOpcionesValidas(array);
    }
    buscarTextoOpcion(value);
  }, [isOpen, value]);

  return (
    <div className={`custom-desplegable-container ${className}`} style={style}>
      <CustomInput
        // label={label}
        value={texto}
        onClick={() => setIsOpen(true)}
        type="button"
        error={error}
        placeholder={placeholder}
        errorHelperText={errorHelperText}
        helperText={helperText}
        disabled={disabled}
        variant={variant}
        startDecorator={
          <Typography
            variant="plain"
            color="neutral"
            className="custom-desplegable-label" // Aplica la clase CSS
            sx={{ fontWeight: "normal" }}
          >
            {label}:
          </Typography>
        }
      />

      <IonModal isOpen={isOpen} onWillDismiss={() => setIsOpen(false)}>
        <IonHeader>
          <IonToolbar>
            <StyledButton
              slot="end"
              fill="clear"
              expand="full"
              onClick={() => setIsOpen(false)}
            >
              Cancelar
            </StyledButton>
            <IonTitle>{label}</IonTitle>
          </IonToolbar>
        </IonHeader>
        <IonContent className="ion-padding">
          {mostrarSearch && (
            <IonSearchbar
              value={searchText}
              onIonInput={(ev) => FiltrarOpciones(ev)}
              debounce={500}
              placeholder="Buscar por nombre"
            />
          )}
          <IonList>
            {mostrarTodos && (
              <IonItem
                key={-1}
                value={-1}
                button
                onClick={() => onHandleChange(-1)}
                className="amarillo-sol"
              >
                <IonLabel>
                  <h5>{"Mostrar todos".toUpperCase()}</h5>
                  <p>{undefined}</p>
                </IonLabel>
                <IonIcon
                  slot="start"
                  icon={
                    -1 !== value ? radioButtonOffOutline : radioButtonOnOutline
                  }
                  size="large"
                />
              </IonItem>
            )}
            {opcionesValidas.map((item) => (
              <IonItem
                key={item.codigo}
                value={item.codigo}
                button
                onClick={() => onHandleChange(item.codigo)}
                className="amarillo-sol"
              >
                {item.imageSrc && (
                  <div className="custom-desplegable-option-image-frame">
                    <img
                      src={item.imageSrc}
                      alt={item.text}
                      className="custom-desplegable-option-image"
                    />
                  </div>
                )}
                <IonLabel>
                  <h5>{item.text}</h5>
                  <p>{item.note}</p>
                </IonLabel>
                <IonIcon
                  slot="start"
                  icon={
                    item.codigo !== value
                      ? radioButtonOffOutline
                      : radioButtonOnOutline
                  }
                  size="large"
                />
              </IonItem>
            ))}
          </IonList>
        </IonContent>
      </IonModal>
    </div>
  );
};

export default CustomDesplegable;
